function Card({ image, title }) {
  return (
    <div
      className="card creation-card text-white position-relative"
      style={{
        backgroundImage: image ? `url(${image})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '450px',
      }}
    >
      {/* Overlay للخلفية */}
      <div className="card-overlay"></div>
      {/* نص العنوان */}
      <h3 className="font-josefin font-light text-2xl text-uppercase text-white position-absolute bottom-0 start-0 m-4 mb-4">
        {title}
      </h3>
      {/* خلفية افتراضية لو الصورة مش موجودة */}
      {!image && (
        <div className="w-100 h-100 bg-dark d-flex align-items-center justify-content-center">
          <p className="text-white">Image not available</p>
        </div>
      )}
    </div>
  );
}

export default Card;